import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Product2 } from '../../../../shared/interfaces/product';
import { ProductService } from '../../../../shared/services/product.service';
import { UserService } from '../../../../shared/services/user.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit {
  header = 'Welk product kies je?';

  products: Product2[];

  constructor(
    private productService: ProductService,
    private router: Router,
    private userService: UserService
  ) {
    if (productService.checkProductsLoaded()) {
      this.products = productService.getAllPrizes();
    }
    this.productService.productsUpdated.subscribe(
      () => (this.products = productService.getAllPrizes())
    );
  }

  ngOnInit() {
    document.body.classList.add('intro');
    document.body.classList.remove('game');
  }

  onClick(product: Product2): void {
    this.userService.selectedProduct = product;
    this.router.navigate(['/start']);
  }
}
